import { render, staticRenderFns } from "./AdminPublishing.vue?vue&type=template&id=6f696130&"
import script from "./AdminPublishing.vue?vue&type=script&lang=js&"
export * from "./AdminPublishing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports